export default {
  default: () => import("/app/.app/layouts/default.vue").then(m => m.default || m),
  collapse: () => import("/app/layers/tairo-layout-collapse/layouts/collapse.vue").then(m => m.default || m),
  empty: () => import("/app/layers/tairo/layouts/empty.vue").then(m => m.default || m)
}